__turbopack_context__.v({
  "eyebrow": "SocialMediaMarketingServicesCardSection-module__Nxe4_q__eyebrow",
  "heading": "SocialMediaMarketingServicesCardSection-module__Nxe4_q__heading",
  "section": "SocialMediaMarketingServicesCardSection-module__Nxe4_q__section",
  "title": "SocialMediaMarketingServicesCardSection-module__Nxe4_q__title",
});
